import { Component, signal } from '@angular/core';
import { CorpPopMenuComponent } from '@corporate-tailwind/component';
import { CorpTranslateService } from '@corporate-tailwind/translation';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Lang } from 'libs/ui/translation/src/lib/language.model';

const LANG_COOKIE_KEY = 'lang';
const LANG_COOKIE_EXPIRES_DAYS = 365;

@Component({
    selector: 'widget-language-switcher',
    imports: [TranslateModule, CorpPopMenuComponent],
    templateUrl: './language-switcher.widget.html',
    styleUrl: './language-switcher.widget.scss',
})
export class LanguageSwitcherWidget {
    currentLang: Lang | null = null;
    langs: readonly Lang[] = [];
    public readonly _lang$ = signal<Lang[] | null>(null);

    constructor(
        private _translateService: TranslateService,
        private _corpTranslateService: CorpTranslateService,
    ) {
        this.langs = this.getLangs(this._translateService.getLangs());
        this._lang$.set(this.getLangs(this._translateService.getLangs()));

        // Initialisation avec la langue active
        this.currentLang = this.getCurrentLang();

        // Applique la langue persistée si disponible
        if (this.currentLang?.code) {
            this._translateService.use(this.currentLang.code);
        }
    }

    ngOnInit(): void {
        this._corpTranslateService.attach(this._lang$);
    }

    switchLanguage(lang: Lang) {
        this._translateService.use(lang.code!);
        this.currentLang = lang;
        this.saveLangCookie(lang.code!);
    }

    private getLangs(languages: readonly string[]): Lang[] {
        console.log('languages', languages)
        let cptId: number = 1;
        let lArray: Lang[] = [];
        languages.forEach((x) => {
            var t = {
                id: cptId,
                code: x,
                label: null,
                labelLCode: `i18n.common.widget.language-menu.${x}`,
                imgPath: `images/flags/${x}.svg`,
            } as Lang;
            lArray.push(t);
            cptId = cptId + 1;
        });
        lArray = this._corpTranslateService.translate(lArray);

        return lArray;
    }

    private getCurrentLang(): Lang | null {
        const cookieLang = this.getLangFromCookie();
        if (cookieLang) {
            const lang = this.langs.find((x) => x.code === cookieLang);
            if (lang) {
                return lang;
            }
        }

        const l = this._translateService.getCurrentLang() || this._translateService.getFallbackLang();
        const lang = this.langs.find((x) => x.code === l);
        return lang ?? null;
    }

    private saveLangCookie(code: string): void {
        const expires = new Date();
        expires.setDate(expires.getDate() + LANG_COOKIE_EXPIRES_DAYS);
        document.cookie = `${LANG_COOKIE_KEY}=${code};expires=${expires.toUTCString()};path=/`;
    }

    private getLangFromCookie(): string | null {
        const match = document.cookie
            .split(';')
            .map((c) => c.trim())
            .find((c) => c.startsWith(`${LANG_COOKIE_KEY}=`));
        return match ? match.split('=')[1] : null;
    }
}
